import { render, staticRenderFns } from "./couponScroll.vue?vue&type=template&id=59e4afb3&scoped=true&functional=true"
import script from "./couponScroll.vue?vue&type=script&lang=js"
export * from "./couponScroll.vue?vue&type=script&lang=js"
import style0 from "./couponScroll.vue?vue&type=style&index=0&id=59e4afb3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "59e4afb3",
  null
  
)

export default component.exports